// Generated by ReScript, PLEASE EDIT WITH CARE


let This = {};

function oneClickConfirmPaymentFn(param, param$1) {
  return Promise.resolve({});
}

function confirmPaymentFn(_elements) {
  return Promise.resolve({});
}

function confirmCardPaymentFn(_clientSecretId, _data, _options) {
  return Promise.resolve({});
}

function retrievePaymentIntentFn(_paymentIntentId) {
  return Promise.resolve({});
}

function update(_options) {
  
}

function getElement(_componentName) {
  
}

function fetchUpdates() {
  return new Promise((resolve, param) => {
    setTimeout(() => resolve({}), 1000);
  });
}

let fnArgument = () => new Promise((param, param$1) => {});

function defaultPaymentElement_on(_str, _func) {
  
}

function defaultPaymentElement_collapse() {
  
}

function defaultPaymentElement_blur() {
  
}

function defaultPaymentElement_update(_x) {
  
}

function defaultPaymentElement_destroy() {
  
}

function defaultPaymentElement_unmount() {
  
}

function defaultPaymentElement_mount(_string) {
  
}

function defaultPaymentElement_focus() {
  
}

function defaultPaymentElement_clear() {
  
}

function defaultPaymentElement_onSDKHandleClick(_fnArgument) {
  
}

function defaultPaymentElement_confirmPayment(_payload) {
  return Promise.resolve({});
}

let defaultPaymentElement = {
  on: defaultPaymentElement_on,
  collapse: defaultPaymentElement_collapse,
  blur: defaultPaymentElement_blur,
  update: defaultPaymentElement_update,
  destroy: defaultPaymentElement_destroy,
  unmount: defaultPaymentElement_unmount,
  mount: defaultPaymentElement_mount,
  focus: defaultPaymentElement_focus,
  clear: defaultPaymentElement_clear,
  onSDKHandleClick: defaultPaymentElement_onSDKHandleClick,
  confirmPayment: defaultPaymentElement_confirmPayment
};

function create(_options, _options2) {
  return defaultPaymentElement;
}

let errorDict = {};

errorDict["code"] = "sdk_not_ready";

errorDict["message"] = "Default stub — hyper not initialized";

let resultDict = {};

resultDict["status"] = "error";

resultDict["error"] = errorDict;

function defaultFieldHandle_mount(param) {
  
}

function defaultFieldHandle_unmount() {
  
}

function defaultFieldHandle_destroy() {
  
}

function defaultFieldHandle_update(param) {
  
}

function defaultFieldHandle_focus() {
  
}

function defaultFieldHandle_blur() {
  
}

function defaultFieldHandle_clear() {
  
}

function defaultFieldHandle_on(param, param$1) {
  
}

let defaultFieldHandle = {
  mount: defaultFieldHandle_mount,
  unmount: defaultFieldHandle_unmount,
  destroy: defaultFieldHandle_destroy,
  update: defaultFieldHandle_update,
  focus: defaultFieldHandle_focus,
  blur: defaultFieldHandle_blur,
  clear: defaultFieldHandle_clear,
  on: defaultFieldHandle_on
};

function defaultCardForm_create(param, param$1) {
  return defaultFieldHandle;
}

function defaultCardForm_on(param, param$1) {
  
}

function defaultCardForm_confirmPayment() {
  return Promise.resolve(resultDict);
}

function defaultCardForm_deinit() {
  
}

function defaultCardForm_update(param) {
  
}

let defaultCardForm_fields = {
  contents: {}
};

let defaultCardForm = {
  create: defaultCardForm_create,
  on: defaultCardForm_on,
  confirmPayment: defaultCardForm_confirmPayment,
  deinit: defaultCardForm_deinit,
  update: defaultCardForm_update,
  fields: defaultCardForm_fields
};

function defaultVaultCardForm_create(param, param$1) {
  return defaultFieldHandle;
}

function defaultVaultCardForm_on(param, param$1) {
  
}

function defaultVaultCardForm_tokenize() {
  return Promise.resolve(resultDict);
}

function defaultVaultCardForm_deinit() {
  
}

function defaultVaultCardForm_update(param) {
  
}

let defaultVaultCardForm_fields = {
  contents: {}
};

let defaultVaultCardForm = {
  create: defaultVaultCardForm_create,
  on: defaultVaultCardForm_on,
  tokenize: defaultVaultCardForm_tokenize,
  deinit: defaultVaultCardForm_deinit,
  update: defaultVaultCardForm_update,
  fields: defaultVaultCardForm_fields
};

function defaultElement_updateIntent(param) {
  return Promise.resolve(null);
}

function defaultElement_createCardForm() {
  return defaultCardForm;
}

let defaultElement = {
  getElement: getElement,
  update: update,
  fetchUpdates: fetchUpdates,
  create: create,
  updateIntent: defaultElement_updateIntent,
  createCardForm: defaultElement_createCardForm
};

function getCustomerDefaultSavedPaymentMethodData() {
  return null;
}

function getCustomerLastUsedPaymentMethodData() {
  return null;
}

function confirmWithCustomerDefaultPaymentMethod(_confirmParams) {
  return Promise.resolve({});
}

function confirmWithLastUsedPaymentMethod(_confirmParams) {
  return Promise.resolve({});
}

function defaultGetCustomerSavedPaymentMethods(_options) {
  return Promise.resolve(null);
}

function defaultInitPaymentSession_updateIntent(param) {
  return Promise.resolve(null);
}

let defaultInitPaymentSession = {
  getCustomerSavedPaymentMethods: defaultGetCustomerSavedPaymentMethods,
  updateIntent: defaultInitPaymentSession_updateIntent
};

function defaultInitAuthenticationSession_initClickToPaySession(param) {
  return Promise.resolve(null);
}

function defaultInitAuthenticationSession_getActiveClickToPaySession() {
  return Promise.resolve(null);
}

let defaultInitAuthenticationSession = {
  initClickToPaySession: defaultInitAuthenticationSession_initClickToPaySession,
  getActiveClickToPaySession: defaultInitAuthenticationSession_getActiveClickToPaySession
};

function defaultInitPaymentMethodSession_createCardForm() {
  return defaultVaultCardForm;
}

function defaultInitPaymentMethodSession_update(param) {
  
}

function defaultInitPaymentMethodSession_on(param, param$1) {
  
}

function defaultInitPaymentMethodSession_deinit() {
  
}

let defaultInitPaymentMethodSession_fields = {
  contents: {}
};

let defaultInitPaymentMethodSession = {
  createCardForm: defaultInitPaymentMethodSession_createCardForm,
  update: defaultInitPaymentMethodSession_update,
  on: defaultInitPaymentMethodSession_on,
  deinit: defaultInitPaymentMethodSession_deinit,
  fields: defaultInitPaymentMethodSession_fields
};

function defaultHyperInstance_elements(_ev) {
  return defaultElement;
}

function defaultHyperInstance_widgets(_ev) {
  return defaultElement;
}

function defaultHyperInstance_paymentRequest(_ev) {
  return null;
}

function defaultHyperInstance_initPaymentSession(_ev) {
  return defaultInitPaymentSession;
}

function defaultHyperInstance_initAuthenticationSession(_ev) {
  return defaultInitAuthenticationSession;
}

function defaultHyperInstance_paymentMethodsManagementElements(_ev) {
  return defaultElement;
}

function defaultHyperInstance_completeUpdateIntent(param) {
  return Promise.resolve({});
}

function defaultHyperInstance_initiateUpdateIntent() {
  return Promise.resolve({});
}

function defaultHyperInstance_confirmTokenization(param) {
  return Promise.resolve({});
}

function defaultHyperInstance_initPaymentMethodSession(param) {
  return defaultInitPaymentMethodSession;
}

let defaultHyperInstance = {
  confirmOneClickPayment: oneClickConfirmPaymentFn,
  confirmPayment: confirmPaymentFn,
  elements: defaultHyperInstance_elements,
  confirmCardPayment: confirmCardPaymentFn,
  retrievePaymentIntent: retrievePaymentIntentFn,
  widgets: defaultHyperInstance_widgets,
  paymentRequest: defaultHyperInstance_paymentRequest,
  initPaymentSession: defaultHyperInstance_initPaymentSession,
  initAuthenticationSession: defaultHyperInstance_initAuthenticationSession,
  paymentMethodsManagementElements: defaultHyperInstance_paymentMethodsManagementElements,
  completeUpdateIntent: defaultHyperInstance_completeUpdateIntent,
  initiateUpdateIntent: defaultHyperInstance_initiateUpdateIntent,
  confirmTokenization: defaultHyperInstance_confirmTokenization,
  initPaymentMethodSession: defaultHyperInstance_initPaymentMethodSession
};

function eventTypeMapper(event) {
  switch (event) {
    case "blur" :
      return "Blur";
    case "change" :
      return "Change";
    case "clickTriggered" :
      return "Click";
    case "completeDoThis" :
      return "CompleteDoThis";
    case "confirmTriggered" :
      return "ConfirmPayment";
    case "escape" :
      return "Escape";
    case "focus" :
      return "Focus";
    case "oneClickConfirmTriggered" :
      return "OneClickConfirmPayment";
    case "ready" :
      return "Ready";
    case "surchargeInfo" :
      return "SurchargeInfo";
    default:
      return "None";
  }
}

function getStrFromHyperComponentName(hyperComponentName) {
  if (hyperComponentName === "Elements") {
    return "Elements";
  } else {
    return "PaymentMethodsManagementElements";
  }
}

function getHyperComponentNameFromStr(hyperComponentName) {
  if (hyperComponentName === "PaymentMethodsManagementElements") {
    return "PaymentMethodsManagementElements";
  } else {
    return "Elements";
  }
}

let vaultSDKNotLoadedError = resultDict;

export {
  This,
  oneClickConfirmPaymentFn,
  confirmPaymentFn,
  confirmCardPaymentFn,
  retrievePaymentIntentFn,
  update,
  getElement,
  fetchUpdates,
  fnArgument,
  defaultPaymentElement,
  create,
  vaultSDKNotLoadedError,
  defaultFieldHandle,
  defaultCardForm,
  defaultVaultCardForm,
  defaultElement,
  getCustomerDefaultSavedPaymentMethodData,
  getCustomerLastUsedPaymentMethodData,
  confirmWithCustomerDefaultPaymentMethod,
  confirmWithLastUsedPaymentMethod,
  defaultGetCustomerSavedPaymentMethods,
  defaultInitPaymentSession,
  defaultInitAuthenticationSession,
  defaultInitPaymentMethodSession,
  defaultHyperInstance,
  eventTypeMapper,
  getStrFromHyperComponentName,
  getHyperComponentNameFromStr,
}
/*  Not a pure module */
